"use client";
import { jsx as e, jsxs as i } from "react/jsx-runtime";
import * as R from "@radix-ui/react-radio-group";
import { useState as W, useId as j } from "react";
import { twMerge as l } from "tailwind-merge";
import { Badge as k } from "./index.es14.js";
import { RadioGroupItem as G } from "./index.es22.js";
import { Text as s } from "./index.es4.js";
const I = ({ className: x, options: c, onSelect: m }) => {
  var f;
  const b = ((f = c.find((t) => t.selected)) == null ? void 0 : f.id) || null, [n, N] = W(b), v = j(), w = "inline-block w-[24px] mr-2 max-w-[24px] max-h-[24px] leading-[var(--text-base--line-height-mobile)] md:text-base-tablet md:leading-[var(--text-base--line-height-tablet)] lg:text-base lg:leading-[var(--text-base--line-height)]", z = (t) => {
    N(t), m == null || m(t);
  };
  return /* @__PURE__ */ e(
    R.Root,
    {
      "data-slot": "radio-group",
      "aria-label": "Radio Group",
      className: l("grid gap-4 w-full", x),
      onValueChange: z,
      value: n,
      children: c.map(
        ({ label: t, subLabel: g, rightLabel: h, badge: p, disabled: a, icon: u, calloutText: d, ctaText: o, onCtaClick: C, id: r }, F) => {
          const y = `${v}-radio-${F}`;
          return /* @__PURE__ */ e("div", { children: /* @__PURE__ */ i(
            "label",
            {
              htmlFor: y,
              className: l(
                "block bg-white cursor-pointer ring-1 ring-gray-300 px-4 py-6 rounded-md relative",
                n === r && "ring-blue-500 ring-2",
                a && "bg-gray-200 cursor-not-allowed"
              ),
              children: [
                p && n === r && /* @__PURE__ */ e(
                  k,
                  {
                    size: "small",
                    text: p,
                    fontWeight: "semibold",
                    className: "absolute -top-3 left-3 bg-blue-500 py-1"
                  }
                ),
                /* @__PURE__ */ i("div", { className: "flex justify-start gap-2 items-center", children: [
                  /* @__PURE__ */ e(
                    G,
                    {
                      value: r,
                      id: y,
                      disabled: a,
                      checked: n === r
                    }
                  ),
                  /* @__PURE__ */ i("div", { className: "flex justify-start items-center ml-2", children: [
                    u && /* @__PURE__ */ e("div", { className: l(w, a && "opacity-50"), children: u }),
                    /* @__PURE__ */ e(
                      s,
                      {
                        fontFamily: "polysans",
                        fontSize: "sm",
                        fontWeight: "semibold",
                        className: l(
                          "font-semibold font-inter text-gray-950",
                          a && "text-gray-500"
                        ),
                        asChild: !0,
                        children: /* @__PURE__ */ e("span", { children: t })
                      }
                    )
                  ] }),
                  h && /* @__PURE__ */ e(
                    s,
                    {
                      fontFamily: "polysans",
                      fontSize: "sm",
                      fontWeight: "semibold",
                      className: l(
                        "font-normal font-inter ml-auto",
                        a && "text-gray-500"
                      ),
                      asChild: !0,
                      children: /* @__PURE__ */ e("span", { children: h })
                    }
                  )
                ] }),
                g && /* @__PURE__ */ e(
                  s,
                  {
                    fontFamily: "polysans",
                    fontSize: "xs",
                    fontWeight: "regular",
                    className: l(
                      "ml-8 mt-2 text-gray-900 font-normal font-inter",
                      a && "text-gray-500"
                    ),
                    children: /* @__PURE__ */ e("span", { children: g })
                  }
                ),
                (d || o) && /* @__PURE__ */ i("div", { className: "flex align-center justify-start ml-8 mt-2", children: [
                  d && /* @__PURE__ */ i(
                    s,
                    {
                      fontFamily: "polysans",
                      fontSize: "base",
                      fontWeight: "bold",
                      className: "text-red-500",
                      children: [
                        /* @__PURE__ */ e("span", { children: d }),
                        o && /* @__PURE__ */ e("span", { className: "ml-1 mr-1 d-block text-gray-900", children: "•" })
                      ]
                    }
                  ),
                  o && /* @__PURE__ */ e(
                    s,
                    {
                      fontFamily: "polysans",
                      fontSize: "base",
                      fontWeight: "bold",
                      className: "text-blue-500",
                      children: /* @__PURE__ */ e("button", { onClick: C, className: "cursor-pointer", children: o })
                    }
                  )
                ] })
              ]
            }
          ) }, r);
        }
      )
    }
  );
};
I.displayName = "RadioGroup";
export {
  I as RadioGroup
};
